import React, { FC } from 'react'

import {
  CloudinaryOptions,
  imageURL,
} from '@Globals/Cloudinary'

export interface ImageOptions extends CloudinaryOptions {
  height?: number
  path: string
  width?: number
}

type ImageProps = {
  options: ImageOptions
} & Omit<JSX.IntrinsicElements['img'], 'src'>

export const Image: FC<ImageProps> = (
  {
    alt = '',
    options: { path, ...options },
    ...rest
  }: ImageProps,
) => (
  <img
    alt={alt}
    src={imageURL(path, options)}
    {...rest}
  />
)
